<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商城后台管理系统</span>
      </div>
      <el-form label-width="50px">
        <el-form-item>
          账号：<el-input type="text" v-model="username"></el-input>
          密码：<el-input type="password" v-model="password" class="pwd"></el-input>
          <el-button type="primary" @click="handlelogin()">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',//admin
      password: ''//root
    }
  },
  mounted() {
    // console.log(document.cookie);
    // if (
    //   document.cookie ===
    //   "_legacy_auth0.Aaj2RxJGoEI7pZziQ0rEUgtFAhM1nzEX.is.authenticated=true; auth0.Aaj2RxJGoEI7pZziQ0rEUgtFAhM1nzEX.is.authenticated=true"
    // ) {
    //   this.$router.push({ path: "/home" });
    // }
  },
  methods: {
    handlelogin() {
      // this.$auth.loginWithRedirect();
      if((this.username == 'cw' && this.password == 'Co&4HINnnYBH_Gz~hymt') ||
      (this.username == 'ym' && this.password == 'QdU9lfiYqYNnhGuCclob') ||
      (this.username == 'cn' && this.password == '%PlNKE~%$=h0mXBWlolf') ||
      //(this.username == 'niushaoyun' && this.password == 'rV__XMKbfwSN?ntOlpeg') ||
      (this.username == 'hjx' && this.password == 'dM8_XLb^z?oai4+Elbmk') ||
      (this.username == 'WXX' && this.password == 'F23tT+Tp~?KvoVwGukvh') ||
      //(this.username == 'zhaorui' && this.password == 'Jnb3#&hbeseGZ^SUoinf') ||
      (this.username == 'zhangshifan77' && this.password == '!n2$~tsn*hqs35Toltfn') ||
      (this.username == 'ywk' && this.password == 'cN9k3@DKS&0Uoyvgklod') ||
      (this.username == 'zq' && this.password == '3AA@Pezuand#Re-?apvi') ||
      (this.username == 'guoqiu' && this.password == '0Vg!u5uSOXwzbUqvR4O$NVjX') ||
      (this.username == 'jf' && this.password == 'ffhb6!j4Q6i+9uefle5l') ||
          (this.username == 'xyz' && this.password == 'sdsdhb6!@i+9ueflp5l') ||
          (this.username == 'xzx' && this.password == 'rMbstwYa@3Mqq)kLm^5OOMmE') ||
      (this.username == 'zmj' && this.password == '42v-t7IfSuZQS@HD54pn')){
        window.localStorage.setItem('un',this.username);
        this.$router.push({ path: "/home/orderlist" });
        // document.cookie=this.username;
      }else if(this.username == '' || this.password == ''){
        this.$message({
          message: '账号或密码不能为空',
          type: 'warning'
        });
      }else if((this.username != 'cw' && 
      this.username != 'ym' &&
      this.username != 'cn' &&
      //this.username != 'niushaoyun' &&
      this.username != 'hjx' && 
      this.username != 'WXX' && 
      //this.username != 'zhaorui' &&
      this.username != 'zhangshifan77' &&
      this.username != 'ywk' &&
      this.username != 'zq' && 
      this.username != 'guoqiu' &&
      this.username != 'jf' &&
      this.username != 'xyz' &&
      this.username != 'zmj') ||
      (this.password != 'Co&4HINnnYBH_Gz~hymt' &&
      this.password != 'QdU9lfiYqYNnhGuCclob' &&
      this.password != '%PlNKE~%$=h0mXBWlolf' &&
      //this.password != 'rV__XMKbfwSN?ntOlpeg' &&
      this.password != 'dM8_XLb^z?oai4+Elbmk' &&
      this.password != 'F23tT+Tp~?KvoVwGukvh' &&
      //this.password != 'Jnb3#&hbeseGZ^SUoinf' &&
      this.password != '!n2$~tsn*hqs35Toltfn' &&
      this.password != 'cN9k3@DKS&0Uoyvgklod' &&
      this.password != '3AA@Pezuand#Re-?apvi' &&
      this.password != '0Vg!u5uSOXwzbUqvR4O$NVjX' &&
      this.password != 'ffhb6!j4Q6i+9uefle5l' &&
      this.password != 'sdsdhb6!@i+9ueflp5l' &&
      this.password != 'rMbstwYa@3Mqq)kLm^5OOMmE' &&
      this.password != '42v-t7IfSuZQS@HD54pn')){
        this.$message({
          message: '账号或密码输入错误',
          type: 'error'
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pwd{
  margin-bottom: 20px;
}
.login {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #409eff;
  .box-card {
    width: 450px;
    margin: 200px auto;
    span {
      font-size: 30px;
      font-weight: bolder;
    }
    .el-button {
      width: 100%;
    }
  }
}
.clearfix {
  padding-left: 30px;
  text-align: center;
}
.el-form,
.clearfix {
  margin-right: 30px;
}
</style>